import { riscoConfig } from "@/config/cta-config";

interface TreeRiskBadgeProps {
  risco: string;
  size?: "sm" | "md";
}

/** Classe de risco da ultima avaliacao.  Sem avaliacao, nao assume "Baixo". */
export default function TreeRiskBadge({ risco, size = "sm" }: TreeRiskBadgeProps) {
  const cfg = risco
    ? riscoConfig[risco] || { badge: "bg-background-100 text-foreground-500", label: risco }
    : { badge: "bg-background-100 text-foreground-400", label: "Sem avaliação" };
  const sizeClass = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-0.5";
  return <span className={`badge ${sizeClass} ${cfg.badge}`}>{cfg.label}</span>;
}
